module.exports = __webpack_public_path__ + "static/media/eshcuFourImg.3b0a0109.jpg";